import {
  FormLabel,
  Stack,
  TextField,
  Tooltip,
  Typography,
  FormControl,
  type SxProps,
} from '@mui/material';
import { useState } from 'react';
import type React from 'react';

import type { FieldValidation } from './validation/fieldValidation';
import { InputErrorIcon } from './validation/inputErrorIcon';

export const FormTextField = ({
  size = 'medium',
  testId,
  title,
  helpText,
  dataTestId,
  validation,
  placeholder,
  value,
  onChange,
  sx,
}: {
  size?: 'small' | 'medium';
  testId?: string;
  title: React.ReactNode;
  helpText?: React.ReactNode;
  dataTestId?: string;
  validation?: FieldValidation;
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
}) => {
  const [touched, setTouched] = useState(false);
  const hasError =
    touched && (validation ? !validation.validateInput(value) : false);

  return (
    <FormControl className='group/help' sx={{ width: '100%', ...sx }}>
      {title && (
        <FormLabel>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <Typography variant='subtitle1'>{title}</Typography>
            {helpText && (
              <Tooltip title={helpText}>
                <i className='material-symbols-help-outline-rounded h-[20px] w-[20px] p-[2px] text-(--mui-palette-text-secondary) opacity-0 group-hover/help:opacity-100 transition-opacity' />
              </Tooltip>
            )}
          </Stack>
        </FormLabel>
      )}
      <TextField
        size={size}
        data-testid={testId}
        onBlur={() => setTouched(true)}
        error={hasError}
        sx={{
          '& .MuiInputBase-root': {
            paddingRight: hasError ? '4px' : '24px',
          },
        }}
        slotProps={{
          htmlInput: { ...(dataTestId ? { 'data-testid': dataTestId } : {}) },
          input: {
            endAdornment: hasError && (
              <InputErrorIcon errorMessage={validation?.errorMessage(value)} />
            ),
          },
        }}
        placeholder={placeholder}
        disabled={false}
        value={value}
        onChange={onChange}
      />
    </FormControl>
  );
};
